{
  "common": {
    "loading": "Carregando...",
    "save": "Salvar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "back": "Voltar",
    "search": "Buscar",
    "viewMore": "Ver mais",
    "viewAll": "Ver tudo"
  },
  "header": {
    "nav": {
      "brands": "Marcas",
      "reviews": "Reviews",
      "causes": "Causas",
      "howItWorks": "Como funciona",
      "about": "Sobre nós"
    },
    "search": {
      "placeholder": "Buscar lojas, produtos e ofertas..."
    },
    "user": {
      "myAccount": "Minha Conta",
      "settings": "Configurações",
      "myCause": "Minha Causa",
      "adminPanel": "Painel Admin",
      "logout": "Sair",
      "fallbackName": "Usuário"
    },
    "menu": {
      "myProfile": "Meu Perfil",
      "navigate": "Navegar"
    },
    "auth": {
      "login": "Entrar",
      "register": "Cadastrar"
    }
  },
  "footer": {
    "tagline": "Transformando compras em doações desde janeiro de 2025.",
    "sections": {
      "forYou": "Para você",
      "institutional": "Institucional",
      "contact": "Contato"
    },
    "links": {
      "howItWorks": "Como funciona",
      "partnerStores": "Lojas Parceiras",
      "causes": "Causas",
      "register": "Cadastre-se",
      "about": "Sobre Nós",
      "howWeGenerate": "Como geramos receita",
      "partner": "Seja Parceiro",
      "privacy": "Privacidade",
      "terms": "Termos de Uso",
      "cookies": "Preferências de cookies",
      "contact": "Fale Conosco"
    },
    "promovendo": {
      "title": "Gerar para Doar",
      "intro": "O Shopping do Bem é uma iniciativa do",
      "brand": "Promovendo o Bem",
      "body": ", organização sem fins lucrativos que pratica o verdadeiro empreendedorismo social. Nossa comissão cobre custos operacionais e",
      "reinvested": "toda sobra é reinvestida em projetos sociais",
      "cta": "Saiba mais"
    },
    "rights": "Todos os direitos reservados."
  },
  "hero": {
    "badgeBrands": "{{count}} marcas parceiras",
    "badgeFallback": "Marcas parceiras",
    "headlineStart": "",
    "headlineHighlight": "Cashback Solidário",
    "headlineEnd1": " é",
    "headlineEnd2": "no Shopping do Bem",
    "lead": "Doar e economizar nunca foi tão fácil.",
    "subheadline": "Você compra pelo mesmo preço nas suas lojas favoritas. A doação acontece sozinha.",
    "ctaStart": "Começar a doar",
    "ctaCause": "Cadastre uma causa",
    "metricsTitle": "Shopping do Bem em números",
    "sinceLine": "Trazendo consciência para o processo de compra desde",
    "stats": {
      "gmv": "em vendas geradas para marcas",
      "raised": "arrecadação confirmada",
      "monitoredProducts": "produtos monitorados",
      "comparableProducts": "produtos para comparar",
      "products50Plus": "produtos com 50% ou mais de desconto",
      "activeCoupons": "cupons de desconto ativos",
      "users": "Usuários",
      "brands": "lojas ativas",
      "causes": "causas ativas",
      "volunteers": "voluntários"
    }
  },
  "brand": {
    "viewCoupon": "Ver cupom",
    "goShopping": "Ir às compras",
    "activateDonation": "Ativar doação"
  },
  "cookie": {
    "message": "Usamos cookies para melhorar sua experiência.",
    "accept": "Aceitar",
    "decline": "Recusar",
    "title": "Sua privacidade",
    "body": "Usamos cookies essenciais e cookies de publicidade (Google AdSense) para sustentar a plataforma e exibir anúncios relevantes. Você pode aceitar ou recusar os cookies de marketing a qualquer momento.",
    "learnMore": "Saiba mais",
    "ariaLabel": "Aviso de cookies",
    "close": "Fechar"
  },
  "howItWorks": {
    "title": "Como funciona",
    "subtitle": "Sua compra sai pelo mesmo preço. A doação acontece sozinha.",
    "closingLead": "O resto da comissão mantém a plataforma de pé. ",
    "closingHighlight": "O que sobra também vira doação",
    "closingTail": ". Um projeto 100% social, feito para gerar impacto.",
    "causeCta": "Cadastre uma causa",
    "steps": {
      "register": {
        "title": "Crie sua conta",
        "description": "Leva menos de um minuto escolher a causa que você quer apoiar."
      },
      "pickStore": {
        "title": "Escolha",
        "description": "São 390 lojas parceiras e mais de 1 milhão de produtos — você compra onde já compra."
      },
      "buy": {
        "title": "Compre normalmente",
        "description": "Clique em 'Ir às compras' e finalize na loja. Sem taxas extras."
      },
      "donate": {
        "title": "A doação acontece",
        "description": "A loja nos paga a comissão e parte dela vira doação para a sua causa."
      }
    }
  },
  "brandsCarousel": {
    "title": "Marcas que fazem a diferença",
    "subtitleWithCount": "Escolha entre nossas {{count}} lojas parceiras. Cada compra gera doações automáticas para a causa que você apoia.",
    "subtitle": "Cada compra gera doações automáticas para a causa que você apoia.",
    "empty": "Nenhuma marca encontrada nesta categoria.",
    "viewAll": "Ver todas as lojas",
    "error": "Não foi possível carregar as marcas.",
    "retry": "Tentar novamente",
    "loading": "Carregando marcas...",
    "donatesUpTo": "Doa até {{value}}"
  },
  "causesShowcase": {
    "title": "Causas que transformam vidas",
    "subtitle": "Escolha uma instituição para apoiar. Sua doação é automática a cada compra que você fizer.",
    "viewAll": "Ver todas as causas",
    "loading": "Carregando causas...",
    "error": "Não foi possível carregar as causas.",
    "retry": "Tentar novamente",
    "empty": "Nenhuma causa encontrada no momento.",
    "viewCause": "Ver Causa",
    "defaultDescription": "Apoie essa causa e transforme vidas.",
    "coverAlt": "Capa de {{name}}"
  }
}
